import {
  createBrowserClient,
  type BrowserClient,
} from "@mfg/adapter-supabase/client";
import type { Database } from "@/types/supabase";

// The browser Supabase client. The singleton is owned by @mfg/adapter-supabase
// (globalThis-keyed), so there's exactly one instance per page. App code never
// imports @supabase/* — only the adapter, which is the boundary library.

/** Typed browser client for app code. */
export function createClient(): BrowserClient<Database> {
  return createBrowserClient<Database>();
}

/** Raw client accessor for the auth ops layer (same singleton, typed). */
export function getRawBrowserClient(): BrowserClient<Database> {
  return createBrowserClient<Database>();
}
